import { render, staticRenderFns } from "./swuserregpsdend.vue?vue&type=template&id=8ea61256&scoped=true&"
import script from "./swuserregpsdend.vue?vue&type=script&lang=js&"
export * from "./swuserregpsdend.vue?vue&type=script&lang=js&"
import style0 from "./swuserregpsdend.vue?vue&type=style&index=0&id=8ea61256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea61256",
  null
  
)

export default component.exports